import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiInfoIconMode } from '../info-icon/info-icon.component';

export enum FiTooltipButtonIconColors {
    Green = 'green-icon',
    Blue = 'blue-icon',
    Red = 'red-icon',
    Branded = 'branded-icon',
    Default = 'default-icon',
}

export enum FiTooltipIconClassType {
    Solid = 'fas',
    Regular = 'far',
    Light = 'fal',
}

@Component({
    selector: 'fi-icon-tooltip-button',
    template: `
        <div
            class="fi-icon-tooltip-wrapper"
            (mouseenter)="setTooltipVisibility(true)"
            (mouseleave)="setTooltipVisibility(false)"
            (click)="iconClick()"
        >
            <mat-icon
                [ngClass]="getIconClass()"
                [class.shown]="isIconVisible"
                [class.blank-icon-background]="isBlankIconBackground"
            />

            @if (!!buttonText?.length) {
                <span class="button-text">{{ buttonText }}</span>
            }

            @if (isTooltipShown()) {
                <fi-info-icon
                    [mode]="FiInfoIconMode.WithoutIconAbsolute"
                    [isTooltipShownFormStart]="isTooltipInstaShown"
                    [fiInfoPosition]="tooltipPosition"
                    [tooltipClass]="tooltipClass"
                    [isIconTooltipShown]="false"
                >
                    <span [innerHTML]="tooltipText"></span>
                </fi-info-icon>
            }
        </div>
    `,
    styleUrls: ['./fi-icon-tooltip-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-icon-tooltip-button' },
    standalone: false,
})
export class FiIconTooltipButtonComponent {
    @Input() isIconVisible: boolean = false;
    @Input() iconClassType: FiTooltipIconClassType = FiTooltipIconClassType.Solid;
    @Input() iconHoverColor: FiTooltipButtonIconColors = FiTooltipButtonIconColors.Green;
    @Input() iconClass: string = 'fa-pencil-alt';
    @Input() isTooltipAvailable: boolean = true;
    @Input() tooltipText: string;
    @Input() isTooltipInstaShown: boolean = false;
    @Output() onIconClick = new EventEmitter<void>();

    @Input() tooltipClass: string | string[] = 'no-arrow';
    @Input() buttonText: string;
    @Input() isBlankIconBackground: boolean = false;
    readonly tooltipPosition: string = 'top';

    private isTooltipVisible: boolean = false;

    protected getIconClass(): string {
        return `${this.iconClassType} ${this.iconClass} ${this.iconHoverColor}`;
    }

    protected isTooltipShown(): boolean {
        return !this.isTooltipInstaShown ? this.isTooltipVisible && this.isTooltipAvailable : true;
    }

    protected setTooltipVisibility(isVisible: boolean): void {
        this.isTooltipVisible = !this.isIconVisible ? false : isVisible;
    }

    protected iconClick(): void {
        this.onIconClick.emit();
    }

    protected readonly FiInfoIconMode = FiInfoIconMode;
}
